<template>
    <div class="main_box">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>基本信息管理</el-breadcrumb-item>
            <el-breadcrumb-item>系统操作员管理</el-breadcrumb-item>
        </el-breadcrumb>

        <el-button class="mt20" size="small" type="primary" @click="handleAdd">新增系统操作员</el-button>
        <el-form class="form" :model="form" :inline="true" size="small" ref="form">
            <el-form-item label="操作员名称" prop="param.username">
                <el-input v-model="form.param.username"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="param.mobile">
                <el-input v-model="form.param.mobile"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="param.email">
                <el-input v-model="form.param.email"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="query">搜索</el-button>
                <el-button @click="$refs.form.resetFields()">清空</el-button>
            </el-form-item>
        </el-form>
        <el-table class="table" :data="data" border>
            <el-table-column label="序号" type="index" width="50px"></el-table-column>
            <el-table-column label="操作员姓名" prop="username" width="95px"></el-table-column>
            <el-table-column label="昵称" prop="nickname" width="100px"></el-table-column>
            <el-table-column label="性别" prop="sex" width="50px" :formatter="formatSex"></el-table-column>
            <el-table-column label="手机号" prop="mobile" width="110px"></el-table-column>
            <el-table-column label="邮箱" prop="email" width="170px"></el-table-column>
            <el-table-column label="地址" prop="addr"></el-table-column>
            <el-table-column label="注册时间" prop="createAt" width="100px">
                <template slot-scope="scope">{{scope.row.createAt | formatTime('yyyy-MM-dd')}}</template>
            </el-table-column>
            <el-table-column label="操作" width="200px">
                <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.enable"
                        active-text="启用"
                        inactive-text="禁用"
                        @change="changeStatus($event,scope.row)"
                    ></el-switch>
                    <el-button type="text" size="small" @click="handleRole(scope.row)">分配角色</el-button>
                </template>
            </el-table-column>
        </el-table>
        <gl-page
            @size-change="sizeChange"
            @current-change="query"
            :current-page="form.pageNum"
            :page-size="form.pageSize"
            :total="total"
        ></gl-page>

        <!--新增界面-->
        <el-dialog
            title="新增操作员"
            :visible.sync="addFormVisible"
            :close-on-click-modal="false"
            size="tiny"
        >
            <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
                <el-form-item label="姓名" prop="username">
                    <el-input v-model="addForm.username" auto-complete="off" class="input_240"></el-input>
                </el-form-item>
                <el-form-item label="手机" prop="mobile">
                    <el-input v-model="addForm.mobile" auto-complete="off" class="input_240"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="addForm.email" auto-complete="off" class="input_240"></el-input>
                </el-form-item>
                <el-form-item label="身份证" prop="idcd">
                    <el-input v-model="addForm.idcd" auto-complete="off" class="input_240"></el-input>
                </el-form-item>
                <el-form-item label="地址" prop="addr">
                    <el-input v-model="addForm.addr" auto-complete="off" class="input_240"></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="sex">
                    <el-radio
                        v-model="addForm.sex"
                        v-for="e in sexes"
                        :key="e.value"
                        :label="e.value"
                    >{{e.text}}</el-radio>
                </el-form-item>
                <el-form-item label="登录密码" prop="password">
                    <el-input
                        type="password"
                        v-model="addForm.password"
                        auto-complete="off"
                        class="input_240"
                    ></el-input>
                </el-form-item>
                <el-form-item label="密码确认" prop="surePassWord">
                    <el-input
                        type="password"
                        v-model="addForm.surePassWord"
                        auto-complete="off"
                        class="input_240"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取 消</el-button>
                <el-button
                    type="primary"
                    @click.native="addSubmit"
                    :loading="addLoading"
                >{{btnAddText}}</el-button>
            </div>
        </el-dialog>

        <!--分配角色界面-->
        <el-dialog
            title="分配角色"
            :visible.sync="handleRoleVisible"
            :close-on-click-modal="false"
            size="tiny"
        >
            <el-form :model="handleRoleForm" label-width="80px" ref="handleRoleForm">
                <el-form-item label="用户编号" prop="userId" style="width:300px;">
                    <el-input
                        type="text"
                        v-model="handleRoleForm.userId"
                        auto-complete="off"
                        :disabled="true"
                    ></el-input>
                </el-form-item>
                <el-form-item label="用户账号" prop="account" style="width:300px;">
                    <el-input
                        type="text"
                        v-model="handleRoleForm.account"
                        auto-complete="off"
                        disabled
                    ></el-input>
                </el-form-item>
                <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="checkAll"
                    @change="handleCheckAllChange"
                >全选</el-checkbox>
                <div style="margin: 15px 0;"></div>
                <el-checkbox-group
                    v-model="handleRoleForm.checkedRoles"
                    @change="handleCheckedRolesChange"
                >
                    <el-checkbox v-for="role in roles" :label="role.id" :key="role.id">{{role.name}}</el-checkbox>
                </el-checkbox-group>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="handleRoleVisible = false">取 消</el-button>
                <el-button
                    type="primary"
                    @click.native="handleRoleSubmit"
                    :loading="handleRoleLoading"
                >{{btnHandleRoleText}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import glPage from '../../components/glPage'
export default {
    components: {
        glPage
    },
    data () {
        return {
            form: {
                pageNum: 1,
                pageSize: 10,
                param: {
                    username: '',
                    mobile: '',
                    email: '',
                },
            },
            data: [],
            total: 0,
            sexes: [
                {
                    value: 1,
                    text: '男'
                },
                {
                    value: 0,
                    text: '女'
                },
                {
                    value: 2,
                    text: '保密'
                }
            ],

            //新增用户
            addForm: {
                username: '',
                mobile: '',
                email: '',
                idcd: '',
                addr: '',
                sex: '',
                password: '',
                surePassword: '',
                app: 'admin',
            },
            addFormRules: {
                username: [{ required: true, message: '请输入操作员姓名', trigger: 'blur' }],
                mobile: [{ required: true, message: '请输入操作员手机号码', trigger: 'blur' }],
                email: [{ required: true, message: '请输入操作员邮箱', trigger: 'blur' }],
                password: [{ required: true, message: '请输入您的登录密码', trigger: 'blur' }],
                surePassWord: [{ required: true, message: '请再次输入您的密码', trigger: 'blur' }],
            },
            addFormVisible: false,
            addLoading: false,
            btnAddText: '提 交',

            //分配角色
            handleRoleForm: {
                userId: '',
                account: '',
                checkedRoles: [],
            },
            checkAll: false,
            isIndeterminate: false,
            roles: [],
            handleRoleVisible: false,
            handleRoleLoading: false,
            btnHandleRoleText: '提 交',
        }
    },
    mounted () {
        this.query();
        this.initRoels();
    },
    methods: {
        query (a) {
            if (isNaN(a)) {
                a = 1
            }
            this.form.pageNum = a
            this.ajax.post('/user/admin/getList', this.form).then(data => {
                this.data = data.list
                this.total = data.total
            })
        },
        sizeChange (a) {
            console.log(a)
            this.form.pageSize = a
            this.query()
        },
        //性别显示转换
        formatSex (row, column) {
            return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '保密';
        },

        reset (form) {
            this.$nextTick(() => {
                this.$refs.dataForm.resetFields()
            });
        },

        //显示新增界面
        handleAdd: function () {
            this.addForm.name = '',
                this.addForm.password = '',
                this.addForm.surePassword = '',
                this.addFormVisible = true;
        },

        //新增
        addSubmit: function () {
            this.$refs.addForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        this.addLoading = true;
                        this.btnAddText = '提交中';
                        this.ajax.post('/user/admin/insert', this.addForm).then(data => {
                            this.$message({
                                type: 'success',
                                message: '操作成功！'
                            })
                            this.addLoading = false;
                            this.btnAddText = '提 交';
                            this.query();
                            this.addFormVisible = false;
                            this.$refs.addForm.resetFields()
                        })
                    }).catch(() => {
                    });
                }
            });
        },
        changeStatus (callback, row) {
            console.log(callback);
            console.log(row);
            let param = {
                id: row.userId,
                enable: callback
            }
            this.ajax.post('/user/admin/change-enable', param).then(data => {
                this.$message({
                    type: 'success',
                    message: '操作成功！'
                })
            })
        },
        handleRole (row) {
            this.handleRoleForm.userId = row.id;
            this.handleRoleForm.account = row.mobile == null ? row.email : row.mobile;
            this.handleRoleLoading = false;
            this.btnHandleRoleText = '提 交';
            this.ajax.get('/user/common/getUserRole', { userId: row.id }).then(data => {
                this.handleRoleForm.checkedRoles = data;
                this.checkAll = this.handleRoleForm.checkedRoles.length === this.roles.length;
                this.handleRoleVisible = true;
            })
        },
        handleCheckAllChange (val) {
            if (val) {
                for (var i in this.roles) {
                    this.handleRoleForm.checkedRoles.push(this.roles[i].id);
                    this.checkAll = true;
                }
                this.isIndeterminate = true;
            } else {
                this.isIndeterminate = false;
            }
        },
        handleCheckedRolesChange (value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.roles.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.roles.length;
        },
        initRoels () {
            this.ajax.get('/role/common/getRoleOptions', {}).then(data => {
                this.roles = data;
            })
        },
        handleRoleSubmit () {
            let count = this.handleRoleForm.checkedRoles.length;
            if (count == 0) {
                this.$message({
                    type: 'error',
                    message: '您还未勾选角色，请勾选！'
                })
                return
            }
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
                this.addLoading = true;
                this.btnAddText = '提交中';
                this.ajax.post('/user/admin/action-roles', this.handleRoleForm).then(data => {
                    this.$message({
                        type: 'success',
                        message: '操作成功！'
                    })
                    this.handleRoleLoading = false;
                    this.btnHandleRoleText = '提 交';
                    this.query();
                    this.handleRoleVisible = false;
                    this.$refs.handleRoleForm.resetFields()
                })
            }).catch(() => {
            });
        }


    }
}
</script>



// WEBPACK FOOTER //
// src/page/basic/userManager.vue